<template>
  <div style="color: #888888; width: 100%; display: inline-block;">
    <span v-if="!question.isValid" style="color: red;">
      {{ question.errorMessage }}
    </span>
    <span v-else>{{ question.valueString }}</span>
    <span v-if="elementPrice !== 0">(${{ elementPrice }})</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CartCardContent',
  dependencies: [
    'CartElementBuilder'
  ],
  props: {
    itemObj: {},
    questionId: {}
  },
  computed: {
    ...mapGetters(['currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    },
    elementPrice () {
      return this.question.currentLevelPrice
    }
  }
}
</script>
